import { RowCrudStatus } from "../../common/types";
import { TenantTokenUsage } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToDateTime } from "../../../common/utils";
import { userDisplayId } from "../..";

export type TenantTokenUsageValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type TenantTokenUsageErrorsType = {};

export function TenantTokenUsageValuesInit(): TenantTokenUsageValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type TenantTokenUsageType =
  | TenantTokenUsage
  | TenantTokenUsageValuesType;

export function tenantTokenUsageDisplayId(
  source: Partial<TenantTokenUsage>,
  _langStore: LangStore
) {
  return (
    `${graphqlToDateTime(source.timestamp)}` +
    (source.conversationUser
      ? userDisplayId(source.conversationUser, _langStore)
      : _langStore.emptyStringSymbol)
  );
}

export function getTenantTokenUsageValues(
  source: TenantTokenUsageType,
  _langStore: LangStore,
  _duplicated: boolean = false
): TenantTokenUsageValuesType {
  const entityValues = TenantTokenUsageValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : tenantTokenUsageDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
